import React, { memo, useEffect } from "react";
import { useDashboardContext } from "../../contexts/dashboard-context";
import { useDefinition } from "../../hooks/useDefinition";
import { useErrorHandling } from "../../hooks/useErrorHandling";
import { useGoogleAnalytics } from "../../hooks/useGoogleAnalytics";
import { useLabels } from "../../hooks/useLabels";
import { useSelectedSpread } from "../../hooks/useSelection";
import { useSnackbar } from "../../hooks/useSnackbar";
import { showCloneSpreadDialog } from "../dialogs/clone-spread-dialog";
import { IconButton } from "../icon-button";
import { labels } from "./labels";

export const CloneButton = memo(() => {
	const { createErrorHandler } = useErrorHandling();
	const selectedSpread = useSelectedSpread();

	const googleAnalytics = useGoogleAnalytics();

	const definition = useDefinition();
	const dashboard = useDashboardContext();
	const hasMultipleOtherSpreads = (definition?.otherSpreadsCount || 0) > 1;
	const isDisabled = !dashboard.canCloneSpreadToAllSpreads(selectedSpread);

	const { addSnackbar } = useSnackbar();

	const [[copySpreadNotificationLabel]] = useLabels([labels.copySpreadsNotification]);

	const showButton = hasMultipleOtherSpreads;
	const onClick = () => {
		googleAnalytics.trackEventToGa({
			trackingAction: "CopySpreadsClicked",
		});
		showCloneSpreadDialog()
			.then((result) => {
				if (result) {
					googleAnalytics.trackEventToGa({
						trackingAction: "CopySpreadsChanged",
					});

					if (dashboard.canCloneSpreadToAllSpreads(selectedSpread)) {
						dashboard.cloneSpreadToAllSpreads(selectedSpread);
						addSnackbar({
							id: "copySpreads",
							text: copySpreadNotificationLabel,
						});
					}
				}
			})
			.catch(createErrorHandler());
	};

	useEffect(() => {
		googleAnalytics.trackEventToGa({
			trackingAction: "CopySpreadsAvailable",
		});
	}, [googleAnalytics]);

	return showButton ? (
		<IconButton iconName="copy" onClick={onClick} elevated disabled={isDisabled} />
	) : null;
});
CloneButton.displayName = "CloneButton";
